export default "__VITE_ASSET__BJVf92lS__";